import erStatus from "./erStatus.json";
import erList from "./erList.json";
import erDetails from "./erDetails.json";

export const exchangeAndReturnPT = { erStatus, erList, erDetails };
